import { useMemo } from 'react';
import { useCart } from '../../../hooks/useCart';

export const useCheckoutGiftSectionError = () => {
  const {
    cart: {
      attributes: { isGiftOrder, isGiftingAllowed }
    }
  } = useCart();

  const error = useMemo(() => {
    if (isGiftOrder && !isGiftingAllowed) {
      return 'Due to updates to your order, it is no longer eligible for gifting options.';
    }

    if (!isGiftingAllowed) {
      return 'This order is not eligible for gifting options.';
    }
  }, [isGiftOrder, isGiftingAllowed]);

  return error;
};
